import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    loginType: localStorage.getItem('loginType') || 'admin' // admin / community
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      localStorage.setItem('userInfo', JSON.stringify(info))
    },
    SET_LOGIN_TYPE(state, type) {
      state.loginType = type
      localStorage.setItem('loginType', type)
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.userInfo = {}
      state.loginType = 'admin'
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('loginType')
    }
  },
  actions: {
    login({ commit }, { token, userInfo, type }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
      commit('SET_LOGIN_TYPE', type)
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
})
